import { render, staticRenderFns } from "./foldouts.vue?vue&type=template&id=5062b789&"
import script from "./foldouts.vue?vue&type=script&lang=js&"
export * from "./foldouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports